import { GameTypeStudent } from "screens/StudentFolder/StudentFolder";
import { AppThunk } from "store";
import {
  loadGameDeffense,
  loadGameHandPlay,
  loadGameMiniBridge,
  loadGameTricks
} from "store/game/thunkActions";
import {
  getExercise,
  getExerciseDefLead,
  getExerciseInteractiveBidding
} from "store/users/thunkActions";

export const validExercise =
  (item: any, type: GameTypeStudent): AppThunk =>
  async (dispatch) => {
    if (type === "bidding") {
      if (!item?.interactive) {
        const res: any = await dispatch(getExercise(item?.exId, item?.courseId));
        if (res?.data?.data?.message === "Expired") {
          return false;
        }
        return res?.data;
      } else {
        const res: any = await dispatch(getExerciseInteractiveBidding(item?.exId));

        if (res?.data?.data?.message === "Expired") {
          return false;
        }
        return res?.data;
      }
    } else if (type === "handPlay") {
      const res: any = await dispatch(loadGameHandPlay(item?.courseId, item?.exIndex));
      if (res?.data?.Status === "Expired") {
        return false;
      }
    } else if (type === "deffense") {
      const res: any = await dispatch(loadGameDeffense(item?.courseId, item?.exIndex));
      if (res?.data?.Status === "Expired") {
        return false;
      }
    } else if (type === "tricks") {
      const res: any = await dispatch(loadGameTricks(item?.courseId, item?.exIndex));
      if (res?.data?.Status === "Expired") {
        return false;
      }
    } else if (type === "defLead") {
      const res: any = await dispatch(getExerciseDefLead(item?.exIndex));
      if (res?.data?.data?.message === "Expired") {
        return false;
      }
    } else if (type === "miniBridge") {
      const res: any = await dispatch(loadGameMiniBridge(item?.courseId, item?.exId));
      if (res?.data?.Status === "Expired") {
        return false;
      }
    }
    return true;
  };
